import React from 'react'
import { ContainerContent, ContainerTemplate } from '../../../components/Containers'
import { Header } from '../../../components/User/Header'
import { Icon } from '../../../components/User/Icon'
import { Title } from '../../../components/User/Title'

export const TemplateSuccess: React.FC = () => {
  return (
    <ContainerTemplate>
      <Header />
      <ContainerContent style={{ justifyContent: 'center' }}>
        <Title text="Parabéns pela sua escolha, em breve você será contatado pelo nosso time!" />
        <Icon text="Ícone de sucesso" path="/images/icons/iconSuccess.svg" />
      </ContainerContent>
    </ContainerTemplate>
  )
}
